import { render, staticRenderFns } from "./BookingAdminItem.vue?vue&type=template&id=3be85af5&"
import script from "./BookingAdminItem.vue?vue&type=script&lang=js&"
export * from "./BookingAdminItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports